import { createSlice } from '@reduxjs/toolkit';
import { fetchSickLeaves, createSickLeave, updateSickLeave, deleteSickLeave } from '../thunks/sickLeaveThunks.js';

const initialState = {
    sickLeaves: [],
    loading: false,
    error: null,
};

const sickLeaveSlice = createSlice({
    name: 'sickLeave',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSickLeaves.fulfilled, (state, action) => {
                state.sickLeaves = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addMatcher(
                (action) =>
                    [
                        fetchSickLeaves.pending.type,
                        createSickLeave.pending.type,
                        updateSickLeave.pending.type,
                        deleteSickLeave.pending.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = null;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchSickLeaves.rejected.type,
                        createSickLeave.rejected.type,
                        updateSickLeave.rejected.type,
                        deleteSickLeave.rejected.type,
                    ].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload || action.error?.message;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        createSickLeave.fulfilled.type,
                        updateSickLeave.fulfilled.type,
                        deleteSickLeave.fulfilled.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = false;
                    state.error = null;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default sickLeaveSlice.reducer;
